// extracted by mini-css-extract-plugin
export default {"container":"kV-z","title":"lV-z","link":"mV-z"};